import type { RouteObject } from 'react-router-dom'

import { PageWindow, type WindowShell } from '@krp/client-runtime'

import { reloadForUpdate } from '../update/reload'
import { HomePage, NotFoundPage } from './pages'
import { RouteError } from './RouteError'
import { Shell } from './Shell'

/**
 * Маршруты — из реестра окон, своего списка разделов нет (R11). Прямой адрес
 * окна и F5 работают: окно восстанавливает ключ из адреса, данные — новым
 * запросом в пустой кэш. Ошибка окна (в том числе не загрузившийся кусок сборки
 * после выкатки) показывается внутри оболочки с кнопкой «Обновить».
 * `browserFetch` — браузерный fetch composition root, нужен перезагрузке мимо кэша.
 */
export function appRoutes(shell: WindowShell, browserFetch: typeof fetch): RouteObject[] {
  return [
    {
      element: <Shell />,
      children: [
        {
          errorElement: <RouteError reload={() => reloadForUpdate(browserFetch)} />,
          children: [
            { index: true, element: <HomePage /> },
            ...shell.routes().map(({ kind, path }) => ({ path, element: <PageWindow kind={kind} /> })),
            { path: '*', element: <NotFoundPage /> },
          ],
        },
      ],
    },
  ]
}
